import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { wasteFields } from './common/wasteFields';
import { msg } from '@lingui/core/macro';

export const wasteProductsMetadata = {
  displayName: msg({
    message: 'Sold products: Waste',
    context: 'Activity data schema name for waste products',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...wasteFields,
    product_weight_quantity: {
      displayName: msg({
        message: 'Product weight quantity',
        context: 'Weight of an individual unit of product.',
      }),
      externalDescription: msg({
        message: 'Weight of an individual unit of product.',
        context: 'Product weight quantity',
      }),
    },
    product_weight_unit: {
      displayName: msg({
        message: 'Product weight unit',
        context: 'Name of a column in table of activity data',
      }),
      externalDescription: msg({
        message: 'The unit of the weight of each order of product',
        context: 'Description of a column in table of activity data',
      }),
    },
    products_sold_quantity: {
      displayName: msg({
        message: 'Products sold: end of life',
        context: 'Total number of products sold',
      }),
      externalDescription: msg({
        message: 'Total number of products sold',
        context: 'Products sold',
      }),
    },
    products_sold_unit: {
      displayName: msg({
        message: 'Unit',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
